import React, { useState } from "react";
import type { WorkspaceNote } from "../../api";

type Props = {
  notes: WorkspaceNote[];
  disabled?: boolean;
  onAdd: (text: string) => void | Promise<void>;
  onDelete: (id: string) => void | Promise<void>;
};

export const NotesPanel: React.FC<Props> = ({ notes, disabled, onAdd, onDelete }) => {
  const [text, setText] = useState("");
  const submit = async (): Promise<void> => {
    const t = text.trim();
    if (!t || disabled) return;
    await onAdd(t);
    setText("");
  };
  return (
    <div className="side-panel notes-panel">
      <div className="side-panel-head">
        <h4>📝 Notizen</h4>
        <span className="side-panel-count">{notes.length}</span>
      </div>
      <div className="side-panel-add">
        <textarea
          rows={2}
          value={text}
          placeholder={disabled ? "Erst Reel speichern…" : "Neue Notiz (Cmd+Enter)…"}
          disabled={disabled}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === "Enter") void submit();
          }}
        />
        <button
          className="btn primary sm"
          onClick={() => void submit()}
          disabled={disabled || text.trim().length === 0}
        >
          Hinzufügen
        </button>
      </div>
      <ul className="side-panel-list">
        {notes.length === 0 ? (
          <li className="side-panel-empty">Noch keine Notizen.</li>
        ) : (
          notes.map((n) => (
            <li key={n.id} className="note-item">
              <div className="note-text">{n.text}</div>
              <div className="note-meta">
                <span>{formatDate(n.createdAt)}</span>
                <button
                  className="link-btn"
                  onClick={() => void onDelete(n.id)}
                  title="Notiz löschen"
                >
                  ✕
                </button>
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}
